<div class="modal-header no-icon">
    <h3 class="modal-title">Workflow</h3>
    <button
        type="button"
        (click)="modal.hide()"
        aria-label="Close"
        class="close"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div *ngIf="workflow != null" class="modal-body">
    <div class="modal-body-content">
        <div class="row workflow">
            <div class="col-xs-12 form-group" *ngIf="hasName">
                <label>Name</label>
                <p>{{ workflow.name }}</p>
            </div>

            <div class="col-xs-12 form-group" *ngIf="currentVersion">
                <label>Version</label>
                <p>
                    Version {{ currentVersion.versionNumber }}
                    {{ activeVersionId === currentVersion.id ? '(Active)' : '' }}
                </p>
            </div>
        </div>

        <ng-container *ngIf="hasDelegatedAuthority && currentVersion">
            <div class="row">
                <div class="col-xs-12 form-group">
                    <label>Primary Authority ID</label>
                    <p *ngIf="currentVersion.delegatedAuthorityId != null">
                        {{ currentVersion.delegatedAuthorityId }}
                    </p>
                    <p *ngIf="currentVersion.delegatedAuthorityId == null" class="text-muted">
                        None
                    </p>
                </div>
            </div>

            <div class="row" *ngIf="currentVersion.additionalAuthorityIds?.length > 0">
                <div class="col-xs-12 form-group">
                    <label>Additional Authorities</label>
                    <ul class="list-unstyled">
                        <li *ngFor="let authorityId of currentVersion.additionalAuthorityIds">
                            {{ authorityId }}
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>

        <div class="row">
            <div class="col-xs-12">
                <h5>Required Documentation (Forms)</h5>
            </div>
        </div>

        <div class="row" *ngIf="currentVersion">
            <div class="col-xs-12">
                <tabset vertical="true" type="pills" class="tab-set-vertical">
                    <tab *ngFor="let step of filterSteps()">
                        <ng-template tabHeading>
                            {{ step.name }}
                            <span class="badge pull-right">
                                {{ countOf(step.value) }}
                            </span>
                        </ng-template>

                        <h5>Forms</h5>
                        <ng-container *ngIf="currentVersion.mappedForms[step.value]?.length > 0; else noForms">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Form</th>
                                        <th>Required</th>
                                        <th>Pre-fill</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let missionForm of currentVersion.mappedForms[step.value]"
                                    >
                                        <td>{{ missionForm.name }}</td>
                                        <td>
                                            <span *ngIf="missionForm.required" class="fa fa-check text-success"></span>
                                            <span *ngIf="!missionForm.required" class="fa fa-times text-muted"></span>
                                        </td>
                                        <td>
                                            <span *ngIf="missionForm.prefill" class="fa fa-check text-success"></span>
                                            <span *ngIf="!missionForm.prefill" class="fa fa-times text-muted"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                        <ng-template #noForms>
                            <p class="text-muted">No forms configured.</p>
                        </ng-template>

                        <h5>Attachments</h5>
                        <ng-container *ngIf="currentVersion.mappedAttachmentRequirements[step.value]?.length > 0; else noAttachments">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Instructions</th>
                                        <th>Min. Instances</th>
                                        <th>Max. Instances</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let attachment of currentVersion.mappedAttachmentRequirements[step.value]"
                                    >
                                        <td>{{ attachment.name }}</td>
                                        <td>{{ attachment.instructions }}</td>
                                        <td>{{ attachment.minimumInstances }}</td>
                                        <td>{{ attachment.maximumInstances }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                        <ng-template #noAttachments>
                            <p class="text-muted">No attachments configured.</p>
                        </ng-template>

                        <div *ngIf="hasApproverChecks && step.value === 'pre-submit'">
                            <h5>Approver Checks</h5>
                            <ng-container *ngIf="currentVersion.mappedApproverChecks[step.value]?.length > 0; else noApproverChecks">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Check</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let approverCheck of currentVersion.mappedApproverChecks[step.value]"
                                        >
                                            <td>{{ approverCheck.check }}</td>
                                            <td>{{ approverCheck.description }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>
                            <ng-template #noApproverChecks>
                                <p class="text-muted">No approver checks configured.</p>
                            </ng-template>
                        </div>
                    </tab>
                </tabset>
            </div>
        </div>
    </div>
</div>
